var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSenior(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 49,
    fill: "#171717"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.1096 28.6431C27.1096 28.6431 36.6392 21.7662 35.5822 13.8957C35.5717 13.762 35.5187 13.6353 35.431 13.5339C35.3335 13.4436 35.2084 13.3888 35.0759 13.3786C27.385 12.2973 20.666 22.0483 20.666 22.0483C14.8367 21.3504 15.2606 22.5127 12.6011 28.9009C12.0922 30.1186 12.917 30.5385 13.8215 30.1956L16.7213 29.1007L20.2178 32.6755L19.1473 35.6442C18.8125 36.5703 19.2215 37.414 20.4136 36.8943C26.656 34.1727 27.7927 34.6074 27.1096 28.6431ZM28.4717 20.6565C28.0833 20.2551 27.8662 19.7185 27.8662 19.16C27.8662 18.6015 28.0833 18.0649 28.4717 17.6635C28.6616 17.4678 28.8889 17.3122 29.14 17.206C29.3911 17.0997 29.6611 17.045 29.9338 17.045C30.2065 17.045 30.4764 17.0997 30.7275 17.206C30.9787 17.3122 31.2059 17.4678 31.3958 17.6635C31.7842 18.0649 32.0014 18.6015 32.0014 19.16C32.0014 19.7185 31.7842 20.2551 31.3958 20.6565C31.2059 20.8522 30.9787 21.0078 30.7275 21.1141C30.4764 21.2203 30.2065 21.2751 29.9338 21.2751C29.6611 21.2751 29.3911 21.2203 29.14 21.1141C28.8889 21.0078 28.6616 20.8522 28.4717 20.6565Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSenior);
export default __webpack_public_path__ + "static/media/Senior.f2e52c59fc45668cad1a26f92069328c.svg";
export { ForwardRef as ReactComponent };